import { render, staticRenderFns } from "./SettingLevel.vue?vue&type=template&id=06ca8f1e&scoped=true&"
import script from "./SettingLevel.vue?vue&type=script&lang=js&"
export * from "./SettingLevel.vue?vue&type=script&lang=js&"
import style0 from "./SettingLevel.vue?vue&type=style&index=0&id=06ca8f1e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ca8f1e",
  null
  
)

export default component.exports